export const initSideCartQuickPay = () => {
  document.addEventListener('DOMContentLoaded', function() {
      const observer = new MutationObserver((mutations, obs) => {
        const shopifyPayButton = document.querySelector('.shopify-cleanslate ul li > div[data-testid="ShopifyPay-button"]');
        if (shopifyPayButton) {
          shopifyPayButton.parentElement.id = 'shop-pay-button';
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
  });
};
